import {useTranslation} from "react-i18next";
import {useEffect, useRef, useState} from "react";

import NavBreadcrumb from "components/NavBreadcrum";
import navs from "./navs";
import axiApi from "ApiCaller";
import TableLogs from "./messagelog/TableLogs";
import LogsFilters from "./messagelog/LogsFilters";
import TopBarActions from "components/TopBarActions";
import ButtonsActions from "../utils/buttonsActions";
import {PRODUCTS} from "site-apps/productListModels";
import LoaderSpinner from "context/LoaderSpinner";
import FilterModel from "components/FilterModel";
import TopBarPagination from "components/paginator/TopBarPagination-v2";
import {PagerModel} from "components/paginator/PaginationModel";
import ItemsModel from "core/itemsModel";
import ModalExport from "./messagelog/ModalExport";

const buttonsActions = new ButtonsActions();

const ViewLogs = () => {
    const {t} = useTranslation("routes");
    const [itemsShown, setItemsShown] = useState([]);
    const [params, setParams] = useState({products: []});
    document.title = t("labels.logs");
    const [buttonsTB, setButtonsTB] = useState({
        ...new ButtonsActions(),
        title: document.title,
    });
    const bread = [
        {name: t("labels.history"), url: "/historic/", current: false},
        {name: t("labels.logs"), current: true},
    ];

    const items = useRef(new ItemsModel());
    const filters = useRef(new FilterModel());
    const [isLoading, setIsLoading] = useState(false);
    const pagerModelRef = useRef(new PagerModel());
    const [, setItem] = useState({});
    const [checkAll, setCheckAll] = useState(false);
    const [, setShowPrev] = useState(false);
    const [showExport, setShowExport] = useState(false);

    useEffect(() => {
        const buttons = {...buttonsActions};
        buttons.title = document.title;
        // buttons.delete.active = true;
        // buttons.delete.onClick = onClickDelete;
        buttons.disabled = true;
        buttons.counter = items.current.showed.length;
        buttons.export.active = true;
        buttons.export.disabled = false;
        buttons.export.onClick = () => setShowExport(true);
        setButtonsTB({...buttons});
        pagerModelRef.current.handleCallApi = () => applyFilters();
        items.current.setItem = setItem;
        items.current.setShowPrev = setShowPrev;
        items.current.item = {};
        fetchGetLogs();
    }, []);

    filters.current.filter = () => {
        pagerModelRef.current.paging.page = 1;
        applyFilters();
    };

    const fetchGetLogs = async () => {
        setIsLoading(true);
        try {
            const resp = await axiApi.get("/api/loggers/messages/");
            if (resp.data && resp.data.items.length) {
                items.current.showed = resp.data.items;
                pagerModelRef.current.active = resp.data.items.length > 0;
                pagerModelRef.current.paging.setPager(resp.data);
                setItemsShown([...resp.data.items]);
                if (resp.data.products) {
                    let products = [];
                    resp.data.products.forEach((key) => {
                        products.push({value: key, label: PRODUCTS[key]});
                    });
                    setParams({...params, products: products});
                }
            }
        } catch (error) {
            console.error("Error al obtener logs:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const applyFilters = async () => {
        setIsLoading(true);
        try {
            const resp = await axiApi.post("/api/loggers/messages/", {
                ...filters.current.chosen,
                ...pagerModelRef.current.paging.getParams(),
            });
            if (resp.data && resp.data.items) {
                items.current.setShowed(resp.data.items);
                pagerModelRef.current.paging.setPager(resp.data);
                pagerModelRef.current.active = resp.data.items.length > 0;
                setItemsShown([...resp.data.items]);
            } else {
                items.current.showed = [];
                setItemsShown([]);
            }
        } catch (error) {
            console.error("Error al obtener logs:", error);
        } finally {
            setIsLoading(false);
        }
    };

    // const onClickDelete = () => {
    //     const alert = new SwalAlertChoice();
    //     alert.params.confirmButtonText = "Borrar";
    //     alert.params.cancelButtonText = "Cancelar";
    //     alert.warning("Atención", `Se borrarán los ${items.current.chosen.length} items seleccionados`).then((result) => {
    //         if (result.isConfirmed) {
    //             deleteItems();
    //         }
    //     });
    // };

    // const deleteItems = () => {
    //     let itemsToDelete = items.current.getChosenIds();
    //     setIsLoading(true);
    //     axiApi
    //         .delete("/api/loggers/delete/", {
    //             data: {ids: itemsToDelete},
    //         })
    //         .then((resp) => {
    //             if (resp.status === 200) {
    //                 pagerModelRef.current.paging.page = 1;

    //                 applyFilters();

    //                 new SwalAlertClass({confirmButtonText: "Aceptar"}).success("Elementos borrados");
    //             } else {
    //                 new SwalAlertClass({confirmButtonText: "Aceptar"}).error(
    //                     "Error",
    //                     "Inténtelo de nuevo más tarde o consulte con su administrador",
    //                 );
    //             }
    //         })
    //         .catch((error) => {
    //             console.error("Error al enviar la solicitud:", error);
    //         })
    //         .finally(() => {
    //             items.current.clearChosen();
    //             setIsLoading(false);
    //         });
    // };

    return (
        <>
            <NavBreadcrumb bread={bread} navs={navs} />
            <TopBarActions actions={buttonsTB} title={t("labels.logs")} />
            <LogsFilters filtersRef={filters} params={params} />
            <TopBarPagination pagerModel={pagerModelRef.current} stickyTopValue="125px" chosen={items.current.chosen} />
            <LoaderSpinner isLoading={isLoading}>
                <TableLogs
                    itemsShow={itemsShown}
                    items={items}
                    checkAll={checkAll}
                    setCheckAll={setCheckAll}
                    buttonsTB={buttonsTB}
                    setButtonsTB={setButtonsTB}
                />
            </LoaderSpinner>
            <ModalExport show={showExport} setShow={setShowExport} filtersRef={filters} />
        </>
    );
};

export default ViewLogs;
